var _rect, _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzApplicantEvidenceJourneyProfileCompletionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz applicant evidence journey profile completion icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 50,
    height: 50,
    rx: 14,
    fill: "#edf6ff",
    stroke: "#80c4ff",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 25,
    r: 8,
    fill: "none",
    stroke: "#087cff",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 47c1-10 5-15 13-15s12 5 13 15",
    fill: "none",
    stroke: "#087cff",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 43,
    r: 10,
    fill: "#ff3885"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42 43 3 3 6-7",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzApplicantEvidenceJourneyProfileCompletionIcon);
export default __webpack_public_path__ + "static/media/talentlenz-applicant-evidence-journey-profile-completion-icon.2d8400aea8930e7d6ca1c76eec5549af.svg";
export { ForwardRef as ReactComponent };